import applicantService from "../../services/applicantService/service";
import applicantModel from "../../models/applicantModel/model";

export default {
    async fetchApplicant(period, search, page, limit, company){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await applicantService.getApplicants(period, sanitizedSearch, page, limit, company);
            return {
                data: data.map(applicant => new applicantModel(applicant)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching applicants:', error);
            throw error;
        }
    },
    async totalAllApplicants(search, company_id){
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await applicantService.totalAllApplicants(sanitizedSearch, company_id);
        } catch (error) {
            console.error('Error fetching applicants:', error);
            throw error;
        }
    },
    async addApplicant(applicant){
        try {
            return await applicantService.addApplicant(applicant);
        } catch (error) {
            console.error('Error adding applicant:', error);
            throw error;
        }
    },
    async updateApplicant(applicant){
        try {
            return await applicantService.updateApplicant(applicant);
        } catch (error) {
            console.error('Error updating applicant:', error);
            throw error;
        }
    },
    async deleteApplicant(applicantId, applicantCv){
        try {
            return await applicantService.deleteApplicant(applicantId, applicantCv);
        } catch (error) {
            console.error('Error deleting applicant:', error);
            throw error;
        }
    },
    async downloadApplicantList(period, company){
        try {
            const response = await applicantService.downloadApplicantList(period, company);
            const data = response.data[0];
            const cvLinks = data.map(applicant => `https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/dokumen/cv/${applicant.cv}`);
            const status_mean = data.map(applicant => {
                if(applicant.status == '0'){
                    return 'Belum diverifikasi';
                }else if(applicant.status == '1'){
                    return 'Tahap Test Wawancara';
                }else if(applicant.status == '2'){
                    return 'Tahap test Kemampuan';
                }else if(applicant.status == '5'){
                    return 'Tahap Test Psikotes';
                }else if(applicant.status == '3'){
                    return 'Diterima';
                }else if(applicant.status == '4'){
                    return 'Ditolak';
                }else{
                    return 'Baru Apply';
                }
            });
            const data_updated = data.map(applicant => {
                return {
                    ...applicant,
                    cv: cvLinks[data.indexOf(applicant)],
                    status: status_mean[data.indexOf(applicant)]
                }
            })
            return data_updated;
        } catch (error) {
            console.error('Error downloading applicant list:', error);
            throw error;
        }
    }
}